import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspacesApi as n } from "@maat/api-main";
//#region src/workspaces/useValidateInviteQuery.ts
var r = (r) => t({
	queryKey: e.validateInvite(r),
	queryFn: () => n.validateInvite(r),
	enabled: !!r,
	retry: !1
});
//#endregion
export { r as useValidateInviteQuery };
